import '../css/output.css';
import { mainNavigationCollapseHelper, initNavAction } from './navigation';
import { initCarouselControls } from './carousel';
import { initAccordionAction } from './accordion';
import { initAlertAction } from './alert';
import {
  initLeafletMapCustomizations,
  configureLocationFeatureMap
} from './location';
import { mapAutocompleteInput } from './mapFilter/autoCompleteInput';
import { mobileFilterControl } from './mapFilter/mobileFilterControl';
import { hideSidebarDuplicatedProjects } from './mapFilter/hideSidebarDuplicatedProjects';
import { initSiteSearchActions } from './siteSearch';
import './mapFilter/popup'; // Import the new popup module
import { initAreasProgressData } from './areasProgressData';
import { initQuickExitButton } from './quickExitButton';
import { initRadioWrapperClick } from './radioWrapperClick';

(function ($, Drupal, once) {
  'use strict';

  /**
   * Behaviour to attach to the DOM.
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.thinkhq_tailwind_css = {
    attach: function (context, settings) {
      try {
        initQuickExitButton(context, once);
        mainNavigationCollapseHelper(context, once);
        initCarouselControls(context, once);
        initAccordionAction(context, once);
        initAlertAction(context, once);
        initNavAction(context, once);
        mapAutocompleteInput(context, settings, once);
        initLeafletMapCustomizations(context, settings, $);
        configureLocationFeatureMap(context, settings, once);
        mobileFilterControl(context, once);
        hideSidebarDuplicatedProjects(context, once);
        initSiteSearchActions(context, once);
        initAreasProgressData(context, settings);
        initRadioWrapperClick(context, once);
      } catch (e) {
        console.error('Error in behavior attach:', e);
      }
    }
  };
})(jQuery, Drupal, once);
